var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('wo-region',[_c('wo-layout',[_c('wo-typography',{directives:[{name:"t",rawName:"v-t",value:(_vm.labelKey),expression:"labelKey"},{name:"wo-color",rawName:"v-wo-color.light",modifiers:{"light":true}}]})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }